import React, { Component } from 'react';
import { withLocalize } from 'react-localize-redux';
import OldStyleSection from '../../common/oldStyleSection';
import EvalSummary from './evalSummary';
import EvalPersons from './evalPersons';
import EssCard from './essCard';

class EconomicGroupDetail extends Component {
    render() {
        if (this.props.data === undefined || this.props.data === null)
            return null;

        return (
            <OldStyleSection name={this.props.translate("Report.EconomicGroup.Detail")} hasData isBold isOpen={false}>
                {this.anyData(this.props.data.finalOwners) && <EssCard>
                    <div className="eval-summaries">
                        <EvalSummary evaluation={this.props.data.finalOwners} />
                    </div>
                    <EssCard title={this.props.translate("Report.EconomicGroup.PersonsWithHighestScore")}>
                        <EvalPersons showShare weightedScore columns={9} persons={this.props.data.finalOwners.high} />
                    </EssCard>
                    <EssCard title={this.props.translate("Report.EconomicGroup.PersonsWithLowestScore")}>
                        <EvalPersons showShare weightedScore columns={9} persons={this.props.data.finalOwners.low} />
                    </EssCard>
                </EssCard>}
                {this.anyData(this.props.data.neighborhood) && <EssCard>
                    <div className="eval-summaries">
                        <EvalSummary evaluation={this.props.data.neighborhood} />
                    </div>
                    <EssCard title={this.props.translate("Report.EconomicGroup.PersonsWithHighestScore")}>
                        <EvalPersons showShare weightedScore columns={9} persons={this.props.data.neighborhood.high} />
                    </EssCard>
                    <EssCard title={this.props.translate("Report.EconomicGroup.PersonsWithLowestScore")}>
                        <EvalPersons showShare weightedScore columns={9} persons={this.props.data.neighborhood.low} />
                    </EssCard>
                </EssCard>}
                {this.anyData(this.props.data.subject) && <EssCard>
                    <div className="eval-summaries">
                        <EvalSummary evaluation={this.props.data.subject} />
                    </div>
                    <EssCard title={this.props.translate("Report.EconomicGroup.PersonsWithHighestScore")}>
                        <EvalPersons showShare weightedScore columns={9} persons={this.props.data.subject.high} />
                    </EssCard>
                    <EssCard title={this.props.translate("Report.EconomicGroup.PersonsWithLowestScore")}>
                        <EvalPersons showShare weightedScore columns={9} persons={this.props.data.subject.low} />
                    </EssCard>
                </EssCard>}
                <EssCard title={this.props.translate("Report.EconomicGroup.KeyPersons")}>
                    <EvalPersons columns={7} persons={this.props.data.keyPersons}/>
                </EssCard>
            </OldStyleSection>
        )
    }

    anyData = (data) => {
        if (data === undefined || data === null)
            return false;

        for (const key in data) {
            if (data[key] !== undefined && data[key] !== null)
                return true;
        }

        return false;
    }
}

export default withLocalize(EconomicGroupDetail);
